import { Component, Host, State, h } from '@stencil/core';
import { Unsubscribe, store } from '@stencil/redux';
import { AppChallenge, ContinueResponse } from '../../class/class';
import { Language } from '../../enums/const-enums';
import { RootState, initialStore } from '../../redux/store';
import { SignCancel } from '../../service/sign-cancel';
import { handleContinueResponse, logd } from '../../utils/utils';

@Component({
  tag: 'rass-app',
  styleUrl: 'rass-app.scss',
  shadow: false,
})
export class RassApp {
  @State() assetsPath: string;
  @State() language: Language;
  @State() challengeData: AppChallenge;
  unsubscribe!: Unsubscribe;

  componentWillLoad(): void {
    store.setStore(initialStore);
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      const {
        config: { assetsPath, language },
        challengeData,
      } = state;
      return { assetsPath, language, challengeData };
    });
    this.initNativeBridge();
  }

  initNativeBridge(): void {
    const method = this.challengeData.encrypted.method;
    const initVector = this.challengeData.encrypted.init_vector;
    const signingInstructions = this.challengeData.encrypted.payload;
    const submitUrl = this.challengeData.submit_url;
    const jsonExtra = this.challengeData.json_extra;
    // Temporary set up for as long as the back-end doesn't decide if scaling is allowed
    if (!this.challengeData.json_extra?.hasOwnProperty('scaleViewport')) {
      this.challengeData.json_extra.scaleViewport = true;
    }
    const jsonExtraStr = JSON.stringify(jsonExtra);

    const nativeBridgeWindow: AppModel.NativeBridgeWindow = window;
    const nativeBridge =
      nativeBridgeWindow.top.nativeBridge || nativeBridgeWindow.nativeBridge;

    if (nativeBridge?.rass?.sign) {
      nativeBridge.rass.sign(
        method,
        initVector,
        signingInstructions,
        submitUrl,
        jsonExtraStr,
        this.successCallback,
        this.errorCallback,
      );
    }
  }

  private successCallback = (
    result: AppModel.NativeBridgeSuccessPayload,
  ): void => {
    handleContinueResponse(
      new ContinueResponse({ continue_url: result.continueToUrl }),
      'success',
    );
  };

  private errorCallback = (result: AppModel.NativeBridgeErrorPayload): void => {
    new SignCancel()
      .doSignCancel(result.errorCode === 2002)
      .then((resp) => {
        handleContinueResponse(resp, 'canceled');
      })
      .catch((err: Error) => logd(() => console.error(err)));
  };

  render(): void {
    return (
      <Host class="section-app">
        <style>@import url({`'${this.assetsPath}css/sfc-style.css'`});</style>
        <div class="sfc-container body-width" role="form" />
      </Host>
    ) as void;
  }
}
